export const MENU_ITEMS = [
  { title: '仪表盘', path: '/dashboard', icon: 'md-speedometer', permission: 'dashboard_view', desc: '系统概览与快捷入口' },
  { title: '仓储管理', path: '/warehouse', icon: 'md-cube', permission: 'warehouse_view', desc: '扫码入库、出库、库存记录' },
  { title: '客户管理', path: '/customers', icon: 'md-people', permission: 'customers_view', aliases: ['customer_manage'], desc: '客户资料与客户服务' },
  { title: '打包管理', path: '/packing', icon: 'md-cube', permission: 'packing_view', aliases: ['packing_manage'], desc: '包裹打包与装箱处理' },
  { title: '聊天室', path: '/chat', icon: 'ios-chatbubbles', permission: 'chat_view', desc: '客户咨询与内部协作' },
  { title: '运费计算器', path: '/shipping', icon: 'md-calculator', permission: 'shipping_view', desc: '运费试算与国家费率配置' },
  { title: '轨迹查询', path: '/tracking', icon: 'md-navigate', permission: 'tracking_view', desc: '物流轨迹与客户查询' },
  { title: '跟单管理', path: '/follow-up', icon: 'md-clipboard', permission: 'follow_up_view', aliases: ['followup_config_manage'], desc: '订单跟进与异常处理' },
  {
    title: '出库管理',
    name: 'outbound-menu',
    icon: 'md-cube',
    permission: 'follow_up_view',
    desc: '待出库包裹与出库流程',
    children: [
      { title: '待出库包裹列表', key: 'outbound-pending', path: '/outbound-pending' },
      { title: '出库管理', key: 'outbound-manage', path: '/outbound' }
    ]
  },
  { title: '财务管理', path: '/finance', icon: 'logo-yen', permission: 'finance_view', aliases: ['payment_manage'], desc: '费用、账单与收款' },
  { title: '系统设置', path: '/settings', icon: 'md-settings', permission: 'settings_view', desc: '系统参数与业务配置' },
  { title: '图片管理', path: '/media-management', icon: 'ios-images', permission: 'media_management_view', adminOnly: true, desc: '上传策略与 OSS 图片压缩' },
  { title: '添加客户分享', path: '/customer-share-tools', icon: 'md-person-add', permissions: ['customer_manage', 'customer_share_manage'], desc: '添加客户并生成微信分享卡' },
  {
    title: '打单系统',
    name: 'printing-menu',
    icon: 'md-print',
    permission: 'printing_view',
    desc: '面单打印与模板管理',
    children: [
      { title: '订单列表', key: 'printing-list', path: '/printing' },
      { title: '创建订单', key: 'printing-create', path: '/printing', query: { tab: 'create' } }
    ]
  }
]

export function isAdminUser(user) {
  return user && (user.role === 'admin' || user.role === 'super_admin')
}

export function userPermissions(user) {
  return (user && (user.effectivePermissions || user.permissions)) || []
}

export function hasPermission(user, permission, aliases) {
  if (!permission) return true
  const permissions = userPermissions(user)
  return [permission].concat(aliases || []).some(item => permissions.indexOf(item) >= 0)
}

export function hasPermissions(user, permissions) {
  return (permissions || []).every(permission => hasPermission(user, permission))
}

export function canAccessMenuItem(user, item) {
  if (item.adminOnly && !isAdminUser(user)) return false
  if (item.permissions) return hasPermissions(user, item.permissions)
  return hasPermission(user, item.permission, item.aliases)
}

export function visibleMenuItems(user) {
  return MENU_ITEMS
    .filter(item => canAccessMenuItem(user, item))
    .map(item => {
      if (!item.children) return item
      return Object.assign({}, item, { children: item.children.slice() })
    })
}

export function routePermission(path) {
  const item = MENU_ITEMS.find(menu => {
    if (menu.path === path) return true
    return menu.children && menu.children.some(child => child.path === path)
  })
  if (!item) return null
  return {
    permission: item.permission,
    permissions: item.permissions || [],
    aliases: item.aliases || [],
    adminOnly: item.adminOnly || false
  }
}
